import { getExpiresInfo, getPerksInfo } from 'lib/targetedOffers/Offers';

import format from 'lib/format';

import { OFFER_TYPE_CASINO } from './Constants';

const getOfferInfo = targetedOffer => {
  if (!targetedOffer) return {};
  const {
    title,
    perks,
    endDate,
    couponCode,
    termsAndConditions: { link } = {},
    type,
  } = targetedOffer;

  const date = endDate ? new Date(endDate) : '';
  const defaultEndDate = endDate ? format(new Date(endDate), 'MM/dd/yyyy') : '';
  const longEndDate = endDate ? format(new Date(endDate), 'MMMM dd, yyy') : '';

  const { expiresToday, expiresSoon, expiresSameDay } = getExpiresInfo(
    new Date(),
    date,
  );
 
  const perksInfo = getPerksInfo(perks);
  const isExpireToday = expiresSameDay;
  const isExpireSoon = !expiresSameDay && (expiresSoon || expiresToday);

  const isCasino = type === OFFER_TYPE_CASINO ? true : false;

  return {
    defaultEndDate,
    longEndDate,
    expiresToday,
    expiresSoon,
    expiresSameDay,
    couponCode,
    title,
    link,
    perksInfo,
    expiresInfo: { expiresToday, expiresSoon, expiresSameDay },
    isExpireToday,
    isExpireSoon,
    isCasino,
  };
};
export default getOfferInfo;